module.exports = "<form action=\"#\">\r\n    <input type=\"text\" placeholder=\"Поиск\" (input)=\"inputSearchText($event.target)\" />\r\n    <button class=\"btn\" type=\"submit\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/communications/search-communications/search-communications.html
// module id = ./src/app/components/dashboard/communications/search-communications/search-communications.html
// module chunks = main